import React, { useState, useEffect, useContext, useRef } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { fetchGetTypes } from "./Api";
import Cookies from "js-cookie";
import { Contextone } from "./Context";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import Language from "./Language";


const SideNav = () => {
  const [types, setTypes] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [displayPopUp, setDisplayPopUp] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const history = useHistory();
  const uid = Cookies.get("userid");
  const location = useLocation();
  const dropdownRef = useRef(null);
  const countercontext = useContext(Contextone);
  const isurl = countercontext.isDomain;
  const apiUrl = `https://${isurl}`;
  const id01Ref = useRef(null);
  const fetchData = async () => {
    try {
      const data = await fetchGetTypes(apiUrl);
      setTypes(data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const closePopUp = () => {
      setIsPopupOpen(false);
      setDisplayPopUp(false);
    };
  
    const openPopUp = () => {
      setDisplayPopUp(true);
      setIsPopupOpen(true);
    };
  
    const handleLogout = () => {
      signOut(auth)
        .then(() => {
          setDisplayPopUp(false);
          sessionStorage.clear();
          history.push("/");
        })
        .catch((error) => {
          console.error("Login Error:", error);
        });
      countercontext.setIsLogged(false);
      countercontext.setIsLogOutButton(true);
      localStorage.removeItem("userid");
      Cookies.remove("userid");
      localStorage.removeItem("userPhone");
      setDisplayPopUp(false);
      history.push("/");
      closePopUp();
    };

  useEffect(() => {
    fetchData();
  }, [location]);

  const handleNavLinkClick = (path) => {
    if (history.location.pathname === path) {
      fetchData();
    }
    const element = document.querySelector(".side-navbar");
    element.style.display = "none";
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      const element = document.querySelector(".side-navbar");
      element.style.display = "none";
    }
  };

  useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };
  }, []);

  const handleSwitchNewsClick = () => {
    countercontext.setShowNewsContent(true);
  };

  return (
    <>
      <div className="side-navbar" ref={dropdownRef}>
          <ul className="side-menu-ul">
            <li>
              <NavLink
                to={"/"}
                className="side-menu"
                onClick={() => handleNavLinkClick("/")}
                activeClassName="active-link"
              >
                Home
              </NavLink>
            </li>
            {types && types.length > 0 ? (
            isurl === 'mahuaplay.ottsnap.in' ? 
              types.filter((type) => type.id !== 5).map((type) => (
                <li key={type.id}>
                  <NavLink
                    to={`/${type.name.replace(/\s+/g, '')}/${type.id}`}
                    activeClassName="active-link"
                    className="side-menu"
                    onClick={() => handleNavLinkClick(`/${type.name.replace(/\s+/g, '')}/${type.id}`)}
                  >
                    {type.name}
                  </NavLink>
                </li>
              )) : 
              types.map((type) => (
                <li key={type.id}>
                  <NavLink
                    to={`/${type.name.replace(/\s+/g, '')}/${type.id}`}
                    activeClassName="active-link"
                    className="side-menu"
                    onClick={() => handleNavLinkClick(`/${type.name.replace(/\s+/g, '')}/${type.id}`)}
                  >
                    {type.name}
                  </NavLink>
                </li>
              ))
          ) : null}

            <Language onClick={() => {
              const element = document.querySelector(".side-navbar");
              if (element) {
                element.style.display = "none";
              }
            }}/>

            <NavLink
              to={"/Subscription"}
              className="menu-bar"
              activeClassName="active-link"
              onClick={() => {
                const element = document.querySelector(".side-navbar");
                if (element) {
                  element.style.display = "none";
                }
              }}
            >
              
              <ul>
                <li className="Otherlist">Subscription</li>
              </ul>
            </NavLink>
            {isurl === "mahuaplay.ottsnap.in" && (
              // <NavLink
              <div
                to={"/"}
                className="menu-bar"
                onClick={handleSwitchNewsClick}
                // activeClassName="active-link"
              >
               
                <ul>
                  <li className="Otherlist"
                  onClick={() => {
                    const element = document.querySelector(".side-navbar");
                    if (element) {
                      element.style.display = "none";
                    }
                  }}>खबरें</li>
                </ul>
              {/* </NavLink> */}
              </div>
            )}


            <>
              {uid ? (
                <>
                  <div className="menu-container">
                    

                    {isurl === "mahuaplay.ottsnap.in" && (
                      <div
                        // to={"/logout"}
                        className="menu-bar"
                        activeClassName="active-link"
                      >
                        <NavLink
                          to={"/Profile"}
                          className="menu-bar"
                          activeClassName="active-link"
                        >
                          
                          <ul>
                            <li className="Otherlist">Profile</li>
                          </ul>
                        </NavLink>
                      </div>
                    )}

                    

                    <NavLink
                      to={"/Rented"}
                      className="menu-bar"
                      activeClassName="active-link"
                    >
                      <img
                        className="Movieslogo"
                        width="50"
                        height="50"
                        // src={rent}
                        src="https://img.icons8.com/?size=100&id=15910&format=png&color=FFFFFF"
                        alt=""
                      />
                      <ul>
                        <li className="Otherlist">Rent</li>
                      </ul>
                    </NavLink>
                    

                    <div
                      // to={"/logout"}
                      className="menu-bar"
                      activeClassName="active-link"
                      onClick={openPopUp}
                    >
                      <img
                        className="Movieslogo"
                        width="50"
                        height="50"
                        // src={logout}
                        src="https://img.icons8.com/?size=100&id=22112&format=png&color=FFFFFF"
                        alt=""
                      />
                      <ul>
                        <li className="Otherlist">Logout</li>
                      </ul>
                    </div>
                    
                  </div>

                </>
              ) : (
                !countercontext.isLogged && (
                  <NavLink
                  to={"/login"}
                  className="menu-bar"
                  activeClassName="active-link"
                  onClick={() => {
                    const element = document.querySelector(".side-navbar");
                    if (element) {
                      element.style.display = "none";
                    }
                  }}             >
                  <img
                    className="Movieslogo"
                    width="50"
                    height="50"
                    src="https://img.icons8.com/external-tal-revivo-bold-tal-revivo/24/FFFFFF/external-login-access-of-user-with-a-right-direction-arrow-classic-bold-tal-revivo.png"
                    
                  />
                  <ul>
                    <li className="Otherlist">Log in</li>
                  </ul>
                </NavLink>
                
                  // </Link>
                )
              )}
            </>
          </ul>

          {displayPopUp && (
        <div>
          <div className={`modal ${isPopupOpen ? "show" : ""}`} ref={id01Ref}>
            <div className="container">
              <p>Are you sure you want to Logout?</p>

              <div className="clearfix">
                <button
                  type="button"
                  onClick={closePopUp}
                  className="cancelbtn"
                >
                  No
                </button>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="removebtn"
                >
                  Sure
                </button>
              </div>
            </div>
          </div>
          {isPopupOpen && <div className="backdrop" onClick={closePopUp} />}
        </div>
      )}

      </div>
    </>
  );
};

export default SideNav;